/**
 * Creates a carousel with the Siema library.
 * data-js-carousel-items - Wrapper of the items that need to act as a carousel.
 * data-js-carousel-per-page - How many items to show per page. This is passed to the Siema perPage option. The format is <screenSize>:<perPage>,<screenSize>:<perPage>
 * data-js-carousel-next - Element that when clicked should move the carousel forward.
 * data-js-carousel-prev - Element that when clicked should move the carousel backward.
 * @param {Object} document
 * @param {Object} moduleHTML
 * @param {Object} appEventEmitter
 * @param {Function} Siema
 */
export default function carousel (document, moduleHTML, appEventEmitter, Siema) {
  const carouselItems = moduleHTML.querySelector('[data-js-carousel-items]')
  if (!carouselItems) throw new Error('Failed to find carousel items.')
  const nextButtonEls = moduleHTML.querySelectorAll('[data-js-carousel-next]')
  const previousButtonEls = moduleHTML.querySelectorAll('[data-js-carousel-prev]')
  const carouselIndicator = moduleHTML.querySelector('[data-js-carousel-indicator]')
  const activeClasses = carouselIndicator && carouselIndicator.dataset && carouselIndicator.dataset.jsCarouselIndicator.split(' ')
  const indicatorItems = Array.from(moduleHTML.querySelectorAll('[data-js-carousel-goto]'))

  let perPage = 1

  if (moduleHTML.dataset.jsCarouselPerPage) {
    try {
      perPage = JSON.parse(moduleHTML.dataset.jsCarouselPerPage)
    } catch (e) {
      throw Error('Carousel per page configuration is wrong. Check https://github.com/pawelgrzybek/siema for more information')
    }
  }

  const setIndicatorState = (classes, el, active) => {
    classes.forEach(cls => el && el.classList && active ? el.classList.add(cls) : el.classList.remove(cls))
  }

  const siema = new Siema({
    selector: carouselItems,
    loop: true,
    perPage,
    onChange: () => {
      activeClasses && indicatorItems.forEach(item => setIndicatorState(activeClasses, item, false))
      // due to how siema handles looping, currentSlide is sometimes negative
      siema.currentSlide >= 0 && activeClasses && setIndicatorState(activeClasses, indicatorItems[siema.currentSlide], true)
    }
  })

  indicatorItems.forEach(item => item.addEventListener('click', () => siema.goTo(item.dataset.jsCarouselGoto)))
  nextButtonEls.forEach((nextButton) => nextButton.addEventListener('click', () => siema.next()))
  previousButtonEls.forEach((previousButton) => previousButton.addEventListener('click', () => siema.prev()))
}
